import styled from 'astroturf/react';

const Wrapper = styled('div')`
  &.isHovering:hover {
    div[class*="filepond--panel-root"] {
      background-color: #efefef !important;
    }
  }

  span[class*="UploadedAt"] {
    font-size: .625em;
    margin-left:50px;
    margin-top:-12px;
  }

  div[class*="filepond--file-status"] {
    margin-left: auto;
    margin-right: 2.25em;
    width: 5.5em;
  }
`;


export default { Wrapper };
